import { render, staticRenderFns } from "./cl-actor-cv.vue?vue&type=template&id=71bba8c0&scoped=true&"
import script from "./cl-actor-cv.vue?vue&type=script&lang=ts&"
export * from "./cl-actor-cv.vue?vue&type=script&lang=ts&"
import style0 from "./cl-actor-cv.vue?vue&type=style&index=0&id=71bba8c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bba8c0",
  null
  
)

export default component.exports